import { Box, TextField } from "@mui/material";
import { format, parse } from "date-fns";
import { sv } from "date-fns/locale";

export type DeterminateDateRange = [Date, Date];

type Props = {
  startText: string;
  endText: string;
  value: DeterminateDateRange;
  onChange?: (newValue: DeterminateDateRange) => void;
};

function parseDate(dateString: string): Date | null {
  const date = parse(dateString, "yyyy-MM-dd", new Date(), { locale: sv });
  if (isNaN(date.getTime())) {
    return null;
  }
  return date;
}

function dateToString(date: Date) {
  return format(date, "yyyy-MM-dd", { locale: sv });
}

const DeterminateDateRangeInput: React.FC<Props> = ({ startText, endText, value, onChange }) => {
  return (
    <Box display="flex" gap={1}>
      <TextField
        label={startText}
        variant="filled"
        type="date"
        value={dateToString(value[0])}
        onChange={(e) => onChange?.([parseDate(e.target.value) || value[0], value[1]])}
        slotProps={{
          inputLabel: { shrink: true },
        }}
      />
      <TextField
        label={endText}
        variant="filled"
        type="date"
        value={dateToString(value[1])}
        onChange={(e) => onChange?.([value[0], parseDate(e.target.value) || value[1]])}
        slotProps={{
          inputLabel: { shrink: true },
        }}
      />
    </Box>
  );
};

export default DeterminateDateRangeInput;
